import React from "react";
import { cn } from "../../lib/utils";

// Sticker-style section heading. `eyebrow` small label, `title` big playful text.
export function SectionHeading({ eyebrow, title, subtitle, align = "center", color = "text-sea-deep", className }) {
  return (
    <div
      className={cn(
        "space-y-3",
        align === "center" ? "text-center mx-auto max-w-2xl" : "text-left",
        className
      )}
    >
      {eyebrow && (
        <span className="inline-block font-display text-coral bg-white rounded-full px-4 py-1 text-sm uppercase tracking-wide shadow-playful">
          {eyebrow}
        </span>
      )}
      <h2 className={cn("font-display text-3xl sm:text-4xl lg:text-5xl leading-tight", color)}>{title}</h2>
      {subtitle && <p className="text-base sm:text-lg text-sea-deep/70 font-semibold">{subtitle}</p>}
    </div>
  );
}
